import React from "react";
import "primereact/resources/primereact.min.css";
import "./styles/theme.css";
import ReactDOM from "react-dom/client";
import "./styles/base-theme.css";
// import { App } from "./App";
import reportWebVitals from "./reportWebVitals";
import "primeicons/primeicons.css";
import "primeflex/primeflex.css";
import "./styles/index.css";
import "quill/dist/quill.snow.css";

import { ToastProvider } from "components/ToastProvider/ToastProvider";
import { PConfirmPopup } from "@prime/PConfirmPopup/PConfirmPopup";
import { PConfirmDialog } from "@prime/PConfirmDialog/PConfirmDialog";
import App from "App";
import { getSentryService } from "services/sentry.service";

getSentryService().init();

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <React.StrictMode>
    <App />
    <ToastProvider />
    <PConfirmPopup />
    <PConfirmDialog />
  </React.StrictMode>,
);

// If you want to start measuring performance in your app pass a function
// or send to an analytics endpoint. Learn more:  https://bit.ly/CRA-vitals

reportWebVitals();
